// 国内仓储
 export const DomesticWarehousingZh = {
  // 中文
  DataStatistics: '数据看板',
  OrderInquiry: '业务类型',
  Date: '日期',
  YearMonthDay: '（年月日）',
  CurrentMonth: '月度',
  CurrentQuarter: '季度',
  CurrentYear: '年度',
  InOutQty: '进出仓作业量',
  Inbound: '入库',
  Outbound: '出库',
  Ticket: ' 票',
  Query: '查询',
  RealTimeInventory: '实时库存量',
  InOutOrders: '进出仓数（票）',
  InboundQty: '进仓量',
  OutboundQty: '出仓量',
  InOutTons: '进出仓数（吨）',
  InventoryTons: '库存数量（吨）',
  InventoryLevel: '库存量',
  Disclaimer: '免责声明：尊敬的客户，本页面显示的业务关数据信息，因存在业务量动态变化以及信息更新滞后等情况，仅供参考，无法律约束力。最终信息，以双方书面确认为准，感谢理解与配合。',
  InboundQuery: '入库查询',
  OrderNumber: '订单号',
  MaterialNumber: '物料号',
  BatchNumber: '批号',
  MaterialName: '物料名称',
  Standards: '规格',
  Warehouse: '仓库',
  DateFrom: '日期从',
  DateTo: '日期到',
  PleaseEnter: '',
  Search: '查询',
  Reset: '重置',
  Export: '导出',
  InboundList: '入库列表',
  InboundDate: '入库日期',
  ControlType: '控制类型',
  PackagingQty: '包装数量',
  PackagingUnit: '包装单位',
  BasicQty: '基本数量',
  BasicUnit: '基本单位',
  NetWeight: '净重',
  GrossWeight: '毛重',
  WarehouseName: '仓库名称',
  OutboundQuery: '出库查询',
  OutboundList: '出库列表',
  OutboundDate: '出库日期',
  InventoryInquiry: '库存查询',
  StockList: '库存列表',
  InboundTime: '入库时间',
  InboundOrder: '入库订单',
  MnemonicCode: '助记码',
  ChineseName: '中文名称',
  EnglishName: '英文名称',
  StockQty: '库存数量',
  AvailableQty: '可用数量',
  ExpirationDate: '失效日期',
  ShelfLife: '临保质天数',
  SubscriptionCenter: '订阅中心',
  PleaseSelectDate: '',
  InboundOperations: '入仓作业量',
  Order: '票',
  CubicMeter: '立方米',
  OutboundOperations: '出仓作业量',
  RealTimeStock: '实时库存量',
  InMOperations: '月度入仓作业量',
  InMonOperationsCtn: '月度入仓作业量（箱数）',
  OutMonOperationsCtn: '月度出仓作业量',
  InventoryMonQtyCMeters: '月库存数量（立方）',
  CubicNumber: '立方数',
  TheCurrentSeason: '季度',
  InQtrOperations: '季度入仓作业量',
  InQtrOperationsCtn: '季度出仓作业数量（箱数）',
  OutQtrOperations: '季度出仓作业量',
  InventoryQtrQtyCMeters: '季度库存数量（立方）',
  TheCurrentYear: '年度',
  InYearOperations: '年度入仓作业量',
  OutYearOperationQtyCtn: '年度出仓作业数量（箱数）',
  OutYearOperations: '年度出仓作业量',
  InventoryYearQtyCMeters: '年库存数量（立方）',
  InWHNumber: '进仓编号',
  IncomingDateFrom: '进仓日期从',
  IncomingDateTo: '进仓日期到',
  SelectDate: '选择日期',
  InWHDate: '进仓日期',
  VinNo: '车牌号',
  Quantity: '入库数量',
   Volume: '体积(m³)',
   Length: '长(cm)',
   Width: '宽(cm)',
  Height: '高(cm)',
  Images: '图片',
  Preview: '预览',
  Download: '下载',
  DownloadAll: '全部下载',
  Remarks: '备注',
  InTotal: '总计',
  StuffingInquiry: '装箱查询',
  CtnNo: '集装箱号',
  MBLNo: '主提单号',
  ETDFrom: '开航日期从',
  LoadFinishDateFrom: '装箱完成日期',
  ETDTo: '开航日期到',
  Vessel: '船名',
  Voyage: '航次',
  ETD: '开航日期',
  PortArea: '港区',
  CtnSize: '箱尺寸',
  CtnSpec: '箱型',
  CtnPict: '箱图片',
  OrderImages: '订单图片',
  Total: '共',
  Articles: '条',
  Page: '页',
  GoTo: '前往',
  Tons: ' 吨',
  InDateFrom: '入库日期从',
  InDateTo: '入库日期到',
  StartTimeEm: '日期开始时间不能为空',
  EndTimeEn: '日期结束时间不能为空',
  DateMonthCanNot: '日期范围不能超过一个月',
  InStartTimeEm: '进仓日期开始时间不能为空',
  OutEndTimeEn: '进仓日期结束时间不能为空',
  StartSailingDate: '开航日期开始时间不能为空',
  EndDepartureDate: '开航日期结束时间不能为空',
  Initial: '初始',
  Confirmed: '确单',
  Entry: '进场',
  Receipt: '收货',
  CompleteReceipt: '收货完成',
  Load: '装车',
  Shipped: '发货完成',
  CtnTypeSize: '箱尺寸',
  StuffingList: '出库列表',
  InTonsQty: '进出仓作业量',
  CFSRealTimeStock: '实时库存量',
  InPickingQty: '在拣库存',
  DC: 'DC',
  CFS: 'CFS'
}

export const DomesticWarehousingEn = {
  // 英文
  DC: 'Distribution Center',
  CFS: 'Container Freight Station',
  DataStatistics: 'Dashboard',
  OrderInquiry: 'Category',
  Date: 'Date',
  Query: 'Search',
  YearMonthDay: '(Year Month Day)',
  CurrentMonth: 'Month',
  CurrentQuarter: 'Quarter',
  CurrentYear: 'Year',
  InOutQty: 'Inbound and Outbound Orders',
  InTonsQty: 'Inbound and Outbound Tons',
  Inbound: 'Inbound',
  Outbound: 'Outbound',
  Ticket: 'Orders',
  RealTimeInventory: 'Real-time inventory',
  InOutOrders: 'In/Out (orders)',
  InboundQty: 'Inbound',
  OutboundQty: 'Outbound',
  InOutTons: 'In/Out (tons)',
  InventoryTons: 'inventory (tons)',
  InventoryLevel: 'Inventory Qty',
  Disclaimer: 'Disclaimer:  The relevant information displayed on this page is for your reference only. The final information is subject to written confirmation by both parties.',
  InboundQuery: 'Inbound',
  MaterialNumber: 'Material#',
  BatchNumber: 'Batch',
  MaterialName: 'CHN Desc',
  EnglishName: 'ENG Desc',
  Standards: 'Specification',
  Warehouse: 'Warehouse',
  DateFrom: 'Date',
  DateTo: '~',
  SelectDate: '',
  Search: 'Search',
  Reset: 'Reset',
  Export: 'Export',
  InboundList: 'Inbound list',
  OrderNumber: 'Order#',
  InboundDate: 'Entry Date',
  ControlType: 'Control Type',
  PackagingQty: 'Package Qty',
  PackagingUnit: 'Package Unit',
  BasicQty: 'Base Qty',
  BasicUnit: 'Base UOM',
  NetWeight: 'NWT',
  GrossWeight: 'GWT',
  WarehouseName: 'Warehouse',
  OutboundQuery: 'Outbound',
  OutboundList: 'Outbound List',
  OutboundDate: 'Outbound Date',
  InventoryInquiry: 'Inventory',
  StockList: 'Inventory List',
  InboundTime: 'Entry Date',
  InboundOrder: 'Order#',
  MnemonicCode: 'Mnemonic Code',
  ChineseName: 'CHN Desc',
  StockQty: 'Inventory Qty',
  AvailableQty: 'Available Qty',
  ExpirationDate: 'Expire Date',
  ShelfLife: 'Shelf life',
  SubscriptionCenter: 'Subscription',
  Page: 'Page',
  PleaseSelectDate: '',
  InboundOperations: 'Inbound',
  Order: 'Orders',
  CubicMeter: 'Cubic Meters',
  OutboundOperations: 'Stuffing',
  RealTimeStock: 'Real-time inventory Tons',
  CFSRealTimeStock: 'Real-time inventory',
  InMOperations: 'Inbound Operations',
  InMonOperationsCtn: 'Inbound Operations( N.o. of Containers)',
  OutMonOperationsCtn: 'Outbound operations',
  InventoryMonQtyCMeters: 'Inventory Quantity (Cubic Meters)',
  CubicNumber: 'Cubic',
  TheCurrentSeason: 'Quarter',
  InQtrOperations: 'Inbound operations',
  InQtrOperationsCtn: 'Outbound operations ( N.o. of Containers)',
  OutQtrOperations: 'Outbound operations',
  InventoryQtrQtyCMeters: 'Inventory Quantity (Cubic Meters)',
  TheCurrentYear: 'year',
  InYearOperations: ' Number of inbound operations ',
  OutYearOperationQtyCtn: 'Outbound Operation Quantity (N.o.of containers)',
  OutYearOperations: 'Quantity of Outbound operations',
  InventoryYearQtyCMeters: 'Quantity in stock (cubic yards)',
  InWHNumber: 'Inbound#',
  PleaseEnter: '',
  IncomingDateFrom: 'Date',
  IncomingDateTo: '~',
  InWHDate: 'Date',
  VinNo: 'License plate number',
  Quantity: 'Qty',
  Volume: 'Volume(m³)',
  Length: 'Length(cm)',
  Width: 'Width(cm)',
  Height: 'Height(cm)',
  Images: 'Pictures',
  Preview: '(Preview)',
  Download: 'Download',
  DownloadAll: 'Download All',
  Remarks: 'Notes',
  InTotal: 'Total',
  StuffingInquiry: 'Stuffing',
  CtnNo: 'Container#',
  MBLNo: 'MBL#',
  ETDFrom: 'ETD',
  LoadFinishDateFrom: 'Load Finish Date',
  ETDTo: '~',
  Vessel: 'Vessel',
  Voyage: 'Voyage',
  ETD: 'ETD',
  PortArea: 'Harbor District',
  CtnSize: 'Size',
  CtnSpec: 'Container Specifications',
  CtnPict: 'Container Pictures',
  OrderImages: 'Order Pictures',
  Total: 'Total',
  Articles: 'Articles',
  GoTo: 'Go to',
  Tons: 'Tons',
  InDateFrom: 'Entry Date',
  InDateTo: '~',
  StartTimeEm: 'Please input from date and end date to search',
  EndTimeEn: 'Please input from date and end date to search',
  DateMonthCanNot: 'The date range cannot exceed one month',
  InStartTimeEm: 'Please input from date and end date to search',
  OutEndTimeEn: 'Please input from date and end date to search',
  StartSailingDate: 'Please input from date and end date to search',
  EndDepartureDate: 'Please input from date and end date to search',
  Initial: 'Initial',
  Confirmed: 'Confirmed',
  Entry: 'Entry',
  Receipt: 'Receipt',
  CompleteReceipt: 'Completion',
  Load: 'Load',
  Shipped: 'Shipped',
  CtnTypeSize: 'Size',
  StuffingList: 'Stuffing List',
  InPickingQty: 'In Picking Qty'
}
